export default "__VITE_ASSET__074ec083__"